import { createSelector } from "reselect";

export const companyAccessor = state => state.company.company;
export const companiesAccessor = state => state.company.companies;
export const plansAccessor = state => state.company.plans;

export const companySelector = createSelector(
    companyAccessor,
    company => company
);

export const companiesSelector = createSelector(
    companiesAccessor,
    companies => companies
);

export const plansSelector = createSelector(
    plansAccessor,
    plans => plans
);
